import React, { useEffect } from "react";
import { Card, CardBody, CardSubtitle, CardTitle } from "reactstrap";
import PageHeader from "../../components/PageHeader";
import DataComponent from "../../components/DataComponent";

// Form Mask
import InputMask from "react-input-mask"
import MaterialInput from "@material-ui/core/Input"
import useForm from "../../hooks/useForm";
import { testTest } from "../../utils/test";

const TestMask = (props) => {
  const {
    handleOnChange,
    form
  } = useForm({ test: "" })
  useEffect(() => {
    console.log(form)
  }, [form])
  const onChange = (a, b, c, d) => {

    handleOnChange(a)
  }
  return (
    <>
      <PageHeader title="WeCake - Mask" />

      <input type="file" id="fileInput" />
      <button onClick={testTest}>파일 복호화</button>

      <Card>
        <CardBody>
          <CardTitle>Mask Example</CardTitle>
          <br />
          <CardSubtitle className="mb-3">
            <code>.btn-lg</code>,
            <code>.btn-md</code>,
            <code>.btn-sm</code>
            className for additional buttons size.
          </CardSubtitle>
          <br />

          <div className="button-items">

            {/* mask="999-99-999-9999-99-9" */}
            <InputMask
              mask="****************"
              name={'test'}
              value={form.test}
              onChange={onChange}
            >
              {inputProps => (
                <MaterialInput {...inputProps} type="tel" disableUnderline />
              )}
            </InputMask>

            <DataComponent field={{
              type: "button",
              label: "Large",
              size: "lg",
              action: () => { console.log('large button click') }
            }}
            />
          </div>
        </CardBody>
      </Card>

    </>
  );
};

export default TestMask;
